/*
 * Public API Surface of ngx-data-table
 */

export * from './lib/ngx-data-table/ngx-data-table-datasource';
export * from './lib/ngx-data-table/ngx-data-table.component';
export * from './lib/ngx-data-table/ngx-data-table.module';
